const OKR_VIEW_SCREEN_PATH_KEY = "okr-view";
export const OKR_VIEW_SCREEN_PATH = [OKR_VIEW_SCREEN_PATH_KEY];
const okrViewPersistedScreenPath = (okrViewId: string, screenName: string): string[] => [OKR_VIEW_SCREEN_PATH_KEY, screenName, okrViewId];
export const expandedGoalsOkrViewScreenPath = (okrViewId: string): string[] => okrViewPersistedScreenPath(okrViewId, "alignment");
